<template>
  <BaseFetchData :action="loadData" v-slot="fetchDataProps">
    <BaseVeeForm
      v-if="fetchDataProps.status.resolved"
      :action="submit"
      ensure-error-keys-camel-case
      v-slot="formProps"
    >
      <div class="px-4 py-5 sm:px-6">
        <div class="space-y-2">
          <div>
            <ValidationProvider name="user" slim vid="userId">
              <template #default="{ errors }">
                <BaseFormGroup>
                  <BaseFormLabel>{{ $t('contact.assigned_to') }}</BaseFormLabel>
                  <VSelect
                    v-model="formData.userId"
                    :options="userOptions"
                    label="fullName"
                    :reduce="(user) => user.id"
                    :disabled="formProps.isPending"
                    class="vue-select custom-option"
                  >
                    <template #option="{ fullName }">
                      <div class="flex group px-4 py-2 items-center">
                        <p class="text-sm font-medium text-gray-900 group-hover:text-white">
                          {{ fullName }}
                        </p>
                      </div>
                    </template>
                  </VSelect>
                  <BaseFormInlineMessage v-if="errors.length" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </template>
            </ValidationProvider>
          </div>
          <div v-if="formData.userId !== contact.userId" class="flex space-x-2">
            <BaseButton primary small :disabled="formProps.invalid || formProps.isPending">
              Save
            </BaseButton>
            <BaseButton
              type="button"
              primary
              outline
              small
              :disabled="formProps.isPending"
              @click="revertChanges"
            >
              Cancel
            </BaseButton>
          </div>
        </div>
      </div>
    </BaseVeeForm>
  </BaseFetchData>
</template>

<script>
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import { accountMembersClient } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  inject: ['updateContact'],
  data() {
    return {
      formData: {
        userId: null,
      },
      userOptions: [],
    };
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId] || null;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      await this.fetchAccountMembers();
      this.formData.userId = this.contact?.userId || null;
    },
    revertChanges() {
      this.formData.userId = this.contact?.userId || null;
    },
    async fetchAccountMembers() {
      if (typeof this.contact?.accountId === 'undefined') {
        return;
      }

      try {
        const response = await accountMembersClient.list(this.contact.accountId);

        this.setUserOptions(response.data.data.map(mapKeysToCamelCase));
      } catch (error) {
        //
      }
    },
    setUserOptions(users) {
      this.userOptions = users;
    },
    async submit() {
      try {
        this.updateContact(mapKeysToSnakeCase(this.formData));

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
